import { useQuery } from '@tanstack/react-query';
import { supportAssistantService } from '@/services/support-assistant.service';
import type {
  AssistantContextTarget,
  AssistantEmptyStateParams,
} from '@/types/support-assistant';

export function emptyStateParams(
  context: AssistantContextTarget | null | undefined,
): AssistantEmptyStateParams {
  if (!context) return { scopeType: 'none' };
  if (context.type === 'module') {
    return { scopeType: 'module', moduleKey: context.moduleKey, pagePath: context.pagePath };
  }
  return { scopeType: context.type, scopeId: context.id };
}

/** Server-chosen opening state (suggestions + recent threads) for the current context. */
export function useAssistantEmptyState(
  context: AssistantContextTarget | null | undefined,
  enabled = true,
) {
  const params = emptyStateParams(context);
  const keyId =
    params.scopeType === 'module'
      ? `${params.moduleKey}|${params.pagePath}`
      : (params.scopeId ?? '');
  return useQuery({
    queryKey: ['assistant-empty-state', params.scopeType, keyId],
    queryFn: () => supportAssistantService.getEmptyState(params),
    enabled,
    staleTime: 30_000,
  });
}
